import { render, staticRenderFns } from "./fishing-responsible-parties.vue?vue&type=template&id=3ca1aa1b&scoped=true"
import script from "./fishing-responsible-parties.vue?vue&type=script&lang=js"
export * from "./fishing-responsible-parties.vue?vue&type=script&lang=js"
import style0 from "./fishing-responsible-parties.vue?vue&type=style&index=0&id=3ca1aa1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1aa1b",
  null
  
)

export default component.exports